import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocAssignCustomRolesRoute: InvariantJiraRoute = {
	name: 'eoc-assign-custom-roles',
	path: '/jira/settings/products/ops/role-assignment',
	exact: true,
};
